import { useQuery } from "@apollo/client";
import { type LocationGenerics } from "router/location";
import { Modal } from "components/layouts";
import { type FC } from "react";
import { useSearch } from "react-location";
import { GET_BILL } from "../apollo"
import { BillView, IndustrialBillView, NetBillView } from "components/cards";

export const BillViewContainer: FC<{
  id?: string;
  actions?: string[];
  open: boolean;
  setOpen: () => void; 
  refetch?: () => void;
}> = ({ setOpen, open, id }) => {
  const searchParams = useSearch<LocationGenerics>();

  const { data, loading } = useQuery(GET_BILL, {
    variables: {
      id: id || searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      hidePadding
      title="Bill Information"
      size="7xl"
      description="Details of bill are shown below"
    >
      <div className="flex flex-col p-6 overflow-y-auto">
        {data?.bill?.billingCycle?.category === "NET" ? (
          <NetBillView bill={data?.bill} />
        ) : data?.bill?.billingCycle?.category === "AMR" ? (
          <IndustrialBillView bill={data?.bill} />
        ) : (
          <BillView bill={data?.bill} />
        )}
      </div>
    </Modal>
  );
};
